import { Entry } from './components/Entry';
import { WorkflowReferer } from './components/Referer';
import { workflowGenerateParmasHandler } from './helpers/helpers';
import processor from './helpers/processor';
import { WorkflowPanel } from './components/Panel';

export default {
  setup({ app }) {
    // 增加导航栏入口
    app.extension.registerComponent('navbar_left', {
      Component: Entry,
    });

    app.extension.registerComponent('right_panel', {
      Component: WorkflowPanel,
    });

    app.extension.registerProcessor('workflow', processor);

    // 注册一个根组件用于页面加载后判断query上是否有workflow的参数并展示蒙层
    app.extension.registerComponent('root', { Component: WorkflowReferer });

    // 注册生图参数和生图结果处理流程
    app.modules.generator.methods.registerGenerateParamsHandler('workflow', workflowGenerateParmasHandler);
  },
};
